import React from 'react'
import PropTypes from 'prop-types'
import TextComponent from '../libs/components/text'

function Text(props) {
  return (
    <div className="min-h-screen flex flex-col items-center p-16">

      <TextComponent type='heading'>Text</TextComponent>

      <a href='https://www.lipsum.com/'>
        <TextComponent className={'mt-24'} type='text-large'>
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        </TextComponent>
      </a>
    </div>
  )
}

export default Text
